import {SkinGrayColorPalette} from "../../../core/gd/skin/skin-palette/@type";
import GrayPalette_GoodDay from "../classic/gray-palette";
import {SkinTheme} from "../@const";


const TEAMS_LIGHT : SkinGrayColorPalette = {

    // Colors from Arthur
    'palette-gray-0'    : '#F7F7F7',
    'palette-gray-1'    : '#F7F7F7',
    'palette-gray-2'    : '#F5F5F5',    // In Teams white color 'FFFFFF'
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3'    : '#F2F2F2',

    'palette-gray-4'    : '#eaeaea',
    'palette-gray-5'    : '#eaeaea',    // From Teams -line it is !!!
    'palette-gray-6'    : '#DADADA',    // dark border ??
    'palette-gray-7'    : '#C4C4C4',
    'palette-gray-8'    : '#AEAEAE',
    'palette-gray-9'    : '#838383',
    'palette-gray-10'   : '#2C2C2C',
    'palette-gray-11'   : '#161616',
}

// This is dark blue
const TEAMS_DARK: SkinGrayColorPalette = {
    'palette-gray-0'    : '#0A0A0A',
    'palette-gray-1'    : '#0A0A0A',    // From teams
    'palette-gray-2'    : '#292929',    // From teams
    'palette-gray-2-value': '#0A0A0A',
    'palette-gray-3'    : '#3E3E3E',    // From teams
    'palette-gray-4'    : '#545454',    // From teams
    'palette-gray-5'    : '#545454',    // From teams
    'palette-gray-6'    : '#696969',
    'palette-gray-7'    : '#7F7F7F',
    'palette-gray-8'    : '#949494',
    'palette-gray-9'    : '#A9A9A9',    // From teams (For test Icon color)
    'palette-gray-10'   : '#BFBFBF',
    'palette-gray-11'   : '#D4D4D4'
}

const DEFAULT_PALETTE = SkinTheme.LIGHT // SkinTheme used like key for palette dictionary

const debug = false
// const debug = "TeamsGrayPalette"

export default class GrayPalette_Teams extends GrayPalette_GoodDay{

    constructor(currentPalette = DEFAULT_PALETTE) {

        super(currentPalette)

        // SkinTheme used like key for palette dictionary !!!
        this.palettes = {
            [SkinTheme.LIGHT]   : TEAMS_LIGHT,
            [SkinTheme.DARK]    : TEAMS_DARK
        }

        this.setPalette(currentPalette)

        debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])
    }

    lightPalettes() {
        return [
            SkinTheme.LIGHT,
            // 'light-2',
            // 'light-3',
            // 'light-4',
            // 'light-5',
        ]
    }

    // getColorHEX(index:number) {
    //     // @ts-ignore
    //     return PALETTES[this.currentPalette] ? '#{0}'.f(PALETTES[this.currentPalette][index]) : '#000000'
    // }
}
